import React, { useState, useEffect } from 'react';
import pb from '../../services/pocketbase';
import Modal from '../../components/Modal/Modal';
import { FaArrowRight } from 'react-icons/fa';
import './Agenda.css';

// Helper function to format date
const formatDate = (dateString) => {
  const date = new Date(dateString);
  const day = date.toLocaleDateString('fr-FR', { day: '2-digit' });
  const month = date.toLocaleDateString('fr-FR', { month: 'short' }).toUpperCase().replace('.', '');
  const year = date.getFullYear();
  return { jour: day, mois: month, annee: year };
};

function Agenda() {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [sortOrder, setSortOrder] = useState('prochain'); // Par défaut : prochain événement

  const openModal = (event) => setSelectedEvent(event);
  const closeModal = () => setSelectedEvent(null);

  // Fonction pour trier les événements avec logique de prochains événements
  const sortEvents = (events, sortType) => {
    const sortedEvents = [...events];
    const now = new Date();
    
    switch (sortType) {
      case 'prochain':
        // Séparer les événements futurs et passés
        const futurs = sortedEvents.filter(e => new Date(e.start_date) >= now);
        const passes = sortedEvents.filter(e => new Date(e.start_date) < now);
        
        // Trier les futurs par date croissante, les passés par date décroissante
        futurs.sort((a, b) => new Date(a.start_date) - new Date(b.start_date));
        passes.sort((a, b) => new Date(b.start_date) - new Date(a.start_date));
        
        return [...futurs, ...passes];
        
      case 'plus_recent':
        return sortedEvents.sort((a, b) => new Date(b.start_date) - new Date(a.start_date));
        
      case 'plus_ancien':
        return sortedEvents.sort((a, b) => new Date(a.start_date) - new Date(b.start_date));
        
      case 'title_asc':
        return sortedEvents.sort((a, b) => a.title.localeCompare(b.title));
        
      case 'location_asc':
        return sortedEvents.sort((a, b) => (a.location || '').localeCompare(b.location || ''));
        
      default:
        return sortedEvents;
    }
  };

  // Événements triés
  const sortedEvents = sortEvents(events, sortOrder);

  useEffect(() => {
    const fetchEvents = async () => {
      try {
        const records = await pb.collection('events').getFullList({
          sort: 'start_date',
        });
        setEvents(records);
      } catch (error) {
        console.error("Erreur lors de la récupération des événements:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchEvents();
  }, []);

  return (
    <div className="agenda-container">
      <h1>Agenda des Événements</h1>
      <p className="agenda-subtitle">Ne manquez aucune de nos apparitions magiques et lancements de collections.</p>
      
      {/* Contrôles de tri dans le même style que le catalogue */}
      <div className="agenda-controls">
        <div className="sort-bar">
          <label htmlFor="sort-select">Trier par :</label>
          <select 
            id="sort-select" 
            value={sortOrder} 
            onChange={(e) => setSortOrder(e.target.value)}
          >
            <option value="prochain">🎯 Prochain événement</option>
            <option value="plus_recent">📅 Plus récent</option>
            <option value="plus_ancien">📅 Plus ancien</option>
            <option value="title_asc">🔤 Titre (A → Z)</option>
            <option value="location_asc">📍 Lieu (A → Z)</option>
          </select>
        </div>
      </div>

      <div className="events-list">
        {loading ? (
          <p>Chargement des événements...</p>
        ) : sortedEvents.length > 0 ? (
          sortedEvents.map((event, index) => {
            const formattedDate = formatDate(event.start_date);
            const now = new Date();
            const isUpcoming = new Date(event.start_date) >= now;
            const isNext = sortOrder === 'prochain' && index === 0 && isUpcoming;
            
            return (
              <div key={event.id} className={`event-card ${isNext ? 'next-event' : ''} ${!isUpcoming ? 'past-event' : ''}`}>
                {isNext && <div className="next-event-badge">🎯 Prochain événement</div>}
                <div className="event-date">
                  <span className="jour">{formattedDate.jour}</span>
                  <span className="mois">{formattedDate.mois}</span>
                  <span className="annee">{formattedDate.annee}</span>
                </div>
                                <div className="event-details">
                  <h3>{event.title}</h3>
                  <p className="event-lieu">{event.location}</p>
                  <p className="event-description-preview">{event.description}</p>
                                    <button onClick={() => openModal(event)} className="btn-savoir-plus">
                    En savoir plus <FaArrowRight />
                  </button>
                </div>
              </div>
            );
          })
        ) : (
          <p>Aucun événement à venir pour le moment.</p>
        )}
            </div>

      {selectedEvent && (
        <Modal isOpen={!!selectedEvent} onClose={closeModal} title={selectedEvent.title}>
          <div className="event-modal-content">
            {selectedEvent.image && (
              <img src={pb.files.getURL(selectedEvent, selectedEvent.image)} alt={selectedEvent.title} className="event-modal-image" />
            )}
            <div className="event-modal-details">
                <p><strong>Quand ?</strong> {new Date(selectedEvent.start_date).toLocaleString('fr-FR', { dateStyle: 'full', timeStyle: 'short' })}</p>
                {selectedEvent.end_date && <p><strong>Jusqu'au :</strong> {new Date(selectedEvent.end_date).toLocaleString('fr-FR', { dateStyle: 'full', timeStyle: 'short' })}</p>}
                <p><strong>Où ?</strong> {selectedEvent.location}</p>
                <p>{selectedEvent.description}</p>
            </div>
          </div>
        </Modal>
      )}
    </div>
  );
}

export default Agenda;